import { html, css, LitElement } from '../../../../../jb-nexus/node_modules/lit';
import * as Toast from '../../../../../jb-nexus/node_modules/bootstrap/js/dist/toast';
import { NexusComponent } from './nexus.component';
import { StorageModule } from './storage.module';

export class ThemePickerComponent extends NexusComponent {

    static properties = {
        title: {
            type: String,
            attribute: true,
        },
        themeId: {
            type: String,
            attribute: true,
            reactive: true,
        },
        theme: {
            attribute: 'theme',
            reflect: true,
        },
        flow: {
            type: String,
            attribute: true,
        },
        state: {
            type: String,
            attribute: true,
            reactive: true,
        },
        button_label: {
            type: String,
            attribute: true,
            reactive: true,
        }
    }

    currentLink = null;
    cachedLink = null;


    translationIdentifiers = {
        'dark_mode': 'Donkere modus',
    };
    createRenderRoot() {
        return this;
    }


    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
			display: flex;  /* or display: block; */
            position: relative;
            margin: 0;
			}
		`;
    }
    constructor() {
        super();
        this.title = null;
        this.button_label = null;
        this.state = null;
        this.themeId = 'light'; // default?
        this.flow = 'icon';
        this.storageModule = new StorageModule();
    }

    prepareTheme() {
        console.log('prepareTheme:', this.themeId);
        // this.themeId = themeId;
        switch (this.themeId) {
            case 'dark':
                this.buildLink();
                this.setBodyTheme('dark');
                this.switchTheme();
                this.handleDarkMode();
                break;
            case 'light':
                // light mode, set attribute
                this.buildLink();
                this.setBodyTheme('light');
                this.switchTheme();
                this.handleLightMode();
                break;
            case 'high-contrast':
                this.buildLink();
                this.setBodyTheme('light');
                this.switchTheme();
                this.handleDarkMode();
                break;
        }

    }

    setBodyTheme(theme) {
        if (this.getBody()) {
            console.log('got body...');
            this.getBody().setAttribute('data-bs-theme', theme);
        }
    }

    buildLink() {
        if (typeof document !== 'undefined') {
            let link = document.querySelector('head link[id="child-style-css"]');
            if (this.cachedLink == null && link) {
                this.cachedLink = link.getAttribute('href');
                console.log('buildLink this.cachedLink', this.cachedLink);
            }
            if (link) {
                let search = 'index2';
                let searchTermStartPosition = this.cachedLink.indexOf(search);
                console.log('buildLink searchTermStartPosition', searchTermStartPosition);
                let stringUpToSearchTermStartPosition = this.cachedLink.substr(0, searchTermStartPosition);
                console.log('buildLink stringUpToSearchTermStartPosition', stringUpToSearchTermStartPosition);
                let stringFromSearchTermStartPositionToEndOfString = this.cachedLink.substr(searchTermStartPosition, this.cachedLink.length);
                console.log('buildLink stringFromSearchTermStartPositionToEndOfString', stringFromSearchTermStartPositionToEndOfString);
                this.cachedStringFromSearchTermStartPositionToEndOfString = stringFromSearchTermStartPositionToEndOfString;
                console.log('cachedStringFromSearchTermStartPositionToEndOfString', this.cachedStringFromSearchTermStartPositionToEndOfString);
                this.currentLink = `${stringUpToSearchTermStartPosition}${this.buildThemeStringPart()}`;
                return;
                // link.setAttribute('href', c);
            }
        }
        return null;
    }

    /**
     * 
     */
    switchTheme() {
        // now make a new link href after the child-style-css, with some identifier;
        let newLink = document.createElement('link');
        newLink.setAttribute('rel', 'stylesheet');
        newLink.setAttribute('id', 'new-child-style-css');
        // add the new file value to its href;
        newLink.setAttribute('href', this.currentLink);
        // remove the previous link child-style-css
        // add child-style-css id to new css link

        let oldLink = document.head.querySelector('#child-style-css');
        console.log('oldLink', oldLink);
        if (oldLink) {
            oldLink.insertAdjacentElement('afterend', newLink);
            document.head.removeChild(oldLink);
            newLink.setAttribute('id', 'child-style-css');
        }
        // this.dispatchEvent(event);
    }

    handleDarkMode() {
        if (typeof document !== 'undefined' && document.documentElement) {
            let body = document.documentElement.querySelector('body');
            if (body) {
                body.setAttribute('data-bs-theme', 'dark');
                // let themableElements = document.querySelectorAll('[theme]');
                // themableElements.forEach(themableElement => {
                //     themableElement.setAttribute('theme', 'dark');
                // });
            }
        }
    }

    handleLightMode() {
        if (typeof document !== 'undefined' && document.documentElement) {
            let body = document.querySelector('body');
            if (body) {
                body.setAttribute('data-bs-theme', 'light');
                let themableElements = document.querySelectorAll('[theme]');
                themableElements.forEach(themableElement => {
                    themableElement.setAttribute('theme', 'light');
                });
            }
        }
    }

    // TODO: Important! Use 'updated' instead of 'update' because 'update' is used to update, and 'updated' is used to handle updated DOM
    updated() {
        // const toasts = this.renderRoot.querySelectorAll('.toast');
        // [...toasts].map(toast => new Toast(toast, {
        //     animation: true,
        //     autohide: false,
        // }));
        // const toast = this.renderRoot.getElementById('liveToast');

        // if (toast) {
        //     const toastBootstrap = Toast.getOrCreateInstance(toast);
        //     toastBootstrap.show();
        //     toast.querySelector('[data-bs-dismiss]').addEventListener('click', () => {
        //         toastBootstrap.hide();
        //     });
        // }
    }

    firstUpdated() {
        console.log('firstUpdated');
        window.addEventListener('load', () => {
            this.handleInitialTheme();
        });
    }

    handleInitialTheme() {
        if (this.getBody()) {
            let prefersDarkColorScheme = parseInt(getComputedStyle(document.documentElement).getPropertyValue(`--nexus-prefers-dark-color-scheme`));
            console.log('handleInitialTheme: prefersDarkColorScheme', prefersDarkColorScheme);
            let nexusThemeSwitched = this.storageModule.getItem('localStorage', 'nexus-theme-switched');
            console.log('handleInitialTheme: nexusThemeSwitched', nexusThemeSwitched);
            let themeLocalStorage = this.storageModule.getItem('localStorage', 'color-theme');
            console.log('handleInitialTheme: themeLocalStorage', themeLocalStorage);
            if (nexusThemeSwitched == null && prefersDarkColorScheme == 1) {
                console.log('handleInitialTheme: NaN and prefers dark, first time visit');
                this.themeId = 'dark';
                this.triggerEventOnElement('user-prefers-dark-color-scheme', this);
                this.prepareTheme();
                return;
            }
            // if (parseInt(nexusThemeSwitched) == 1) {
            if (themeLocalStorage == 'high-contrast') {
                this.themeId = 'high-contrast';
                this.prepareTheme();
                console.log('prefers dark color scheme and theme local storage is', themeLocalStorage);
                return;
            }
            // if ((themeLocalStorage === null || themeLocalStorage === 'light')) {
            // this.themeId = 'dark';
            // this.storageModule.setItem('localStorage', 'color-theme', this.themeId);
            // this.prepareTheme();
            // return;
            // } else {
            themeLocalStorage = this.storageModule.getItem('localStorage', 'color-theme');
            // console.log('themeLocalStorage', themeLocalStorage);
            if (themeLocalStorage) {
                this.themeId = themeLocalStorage;
                this.prepareTheme();
            }
            let themeBodyAttribute = this.getBody().getAttribute('data-bs-theme');
            if (themeBodyAttribute) {
                console.log('themeBodyAttribute', themeBodyAttribute);
                this.themeId = themeBodyAttribute;
                // this.storageModule.setItem('localStorage', 'color-theme', this.themeId);
                this.prepareTheme();
            }
            // }
            // }
        }
        return;
    }

    buildThemeStringPart() {
        let result = '';
        if (this.themeId) {
            result = `index2-${this.themeId}.css`;
        }
        if (this.themeId == 'light') {
            result = `${this.cachedStringFromSearchTermStartPositionToEndOfString}`;
        }
        return result;
    }

    buildThemeStringPartByThemeId(themeId) {
        let result = '';
        if (themeId) {
            result = `-${themeId}`;
        }
        if (themeId == 'light') {
            result = ``;
        }
        return result;
    }


    handleDarkThemeSwitchClick() {
        console.log('handleDarkThemeSwitchClick start', this.themeId, this);
        // this.prepareTheme();
        // this.switchTheme();
        // this.storageModule.setItem('localStorage', 'color-theme', this.themeId);
        console.log('handleDarkThemeSwitchClick end', this.themeId);
        this.triggerEventOnElement('nexus-theme-switched', this, {
            state: this.state,
            themeId: this.themeId,
        });
    }

    getButtonClassBasedOnState(state) {
        let _class = `btn-floating-action-button`;
        switch (state) {
            case 'active':
                _class = `btn-primary`;
                break;
            case 'inactive':
                _class = `btn-floating-action-button`;
                break;
        }
        return _class;
    }

    getButtonIconBackgroundClassBasedOnState(state) {
        let _class = 'bg-primary';
        switch (state) {
            case 'active':
                _class = `bg-light`;
                break;
            case 'inactive':
                _class = `bg-primary`;
                break;
        }
        return _class;
    }

    getButtonIconClassBasedOnState(state) {
        let _class = '';
        switch (state) {
            case 'active':
                _class = `svg-icon-floating-action-button-active`;
                break;
            case 'inactive':
                _class = ``;
                break;
        }
        return _class;
    }

    doRender() {
        let result = html``;
        let _class = 'nav-icon-button'; // default, flow 'icon';
        switch (this.flow) {
            case 'floating-action-button':
                _class = 'btn bg-tertiary w-100';
                result = html`
            <button type="button" @click="${this.handleDarkThemeSwitchClick}" class="btn ${this.getButtonClassBasedOnState(this.state)} w-100" aria-label="Switch between light mode and dark mode">
                <div class="row rounded-0 rounded-top-3 py-3">
                    <div class="col-auto mx-auto mb-2">
                        <div class="row">
                            <div class="col ${this.getButtonIconBackgroundClassBasedOnState(this.state)} rounded-circle p-2">
                                <svg lang="en-GB" class="switch-dark-mode svg-icon svg-icon-hover svg-icon-size-40 static-color align-self-end my-auto ${this.getButtonIconBackgroundClassBasedOnState(this.state)}">
                                    <title>Dark</title>
                                    <use xlink:href="#icon-dark-mode"></use>
                                </svg>
                                <svg lang="en-GB" class="switch-light-mode svg-icon svg-icon-hover svg-icon-size-40 static-color align-self-end my-auto ${this.getButtonIconClassBasedOnState(this.state)}">
                                    <title>Light</title>
                                    <use xlink:href="#icon-light-mode"></use>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 align-self-center fw-bold">
                        ${this.button_label}
                    </div>
                </div>
            </button>
                `;
                break;
            case 'icon':
                _class = 'nav-icon-button';
                result = html`
            <button @click="${this.handleDarkThemeSwitchClick}" type="button" class=${_class} aria-label="Switch between light mode and dark mode">
                    <svg lang="en-GB" class="switch-dark-mode svg-icon svg-icon-hover svg-icon-size-15 static-color align-self-end my-auto">
                    <title>Dark</title>
                        <use xlink:href="#icon-dark-mode"></use>
                    </svg>
                    <svg lang="en-GB" class="switch-light-mode svg-icon svg-icon-hover svg-icon-size-15 static-color align-self-end my-auto">
                        <title>Light</title>
                        <use xlink:href="#icon-light-mode"></use>
                    </svg>
            </button>
                `;
                break;

            default:
                break;
        }
        // <div class="row bg-tertiary-darker rounded-0 rounded-top-3 py-3">
        //     <div class="col-auto">
        //         <div class="bg-light rounded-circle p-2">
        //             <svg class="icon-accessibility svg-icon svg-icon-hover svg-icon-size-30 align-self-end my-auto">
        //             <title>${iconTitle}</title>
        //             <use href="#icon-${iconIdentifier}"></use>
        //         </svg>
        //         </div>
        //     </div>
        //     <div class="col align-self-center">
        //         ${title}
        //     </div>
        // </div>
        return result;
    }

    // _class = `svg-icon-floating-action-button-active`;

    getBody() {
        let body = document.querySelector('body');
        return body;
    }

    render() {
        return html`${this.doRender()}`;
    }

    attributeChangedCallback(name, old, _value) {
        super.attributeChangedCallback(name, old, _value); // gotta call the super's method by same name first!
        console.log('attributeChangedCallback', name, old, _value);
        switch (name) {
            case 'themeid':
                if (old !== null && _value != old) {
                    switch (_value) {
                        case 'light':
                            this.prepareTheme();
                            this.switchTheme();
                            this.storageModule.setItem('localStorage', 'color-theme', _value);
                            this.state = 'inactive';
                            break;
                        case 'dark':
                            this.prepareTheme();
                            this.switchTheme();
                            this.storageModule.setItem('localStorage', 'color-theme', _value);
                            this.state = 'active';
                            break;
                        case 'high-contrast':
                            this.prepareTheme();
                            this.switchTheme();
                            if (old == 'dark' && _value == 'high-contrast') {
                                this.state = 'active';
                            }
                            if (old == 'light' && _value == 'high-contrast') {
                                this.state = 'active';
                            }
                            this.storageModule.setItem('localStorage', 'color-theme', _value);
                            break;
                        // default:
                        //     break;
                    }
                }
                break;
            case 'state':
                if (old !== null && _value != old) {
                    switch (_value) {
                        case 'active':
                            // this.state = 'inactive';
                            break;
                        case 'inactive':
                            // this.state = 'active';
                            break;
                    }
                }
                break;
        }
    }

}
window.customElements.define('theme-picker', ThemePickerComponent);

